import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./routes/HomePage";
import LegalPage from "./routes/LegalPage";

const PortalApp = lazy(() => import("./portal/PortalApp"));

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy" element={<LegalPage page="privacy" />} />
      <Route path="/terms" element={<LegalPage page="terms" />} />
      <Route
        path="/portal/*"
        element={
          <Suspense fallback={<div className="portal-loading">Opening your portal</div>}>
            <PortalApp />
          </Suspense>
        }
      />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}
